import { render, staticRenderFns } from "./CustomAddress.vue?vue&type=template&id=6f1351a5&"
import script from "./CustomAddress.vue?vue&type=script&lang=js&"
export * from "./CustomAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports